import PropTypes from 'prop-types';
import React from 'react';
import {Label} from 'semantic-ui-react';

const colorTypes = PropTypes.oneOf(
	[
		'mred',
		'red',
		'pink',
		'purple',
		'deep-purple',
		'indigo',
		'blue',
		'blight',
		'cyan',
		'teal',
		'green',
		'light-green',
		'lime',
		'yellow',
		'amber',
		'orange',
		'deep-orange',
		'brown',
		'blue-grey',
		'grey'
	].flatMap(c => [c, `light ${c}`, `dark ${c}`])
);
const LabelCheckBox = ({value, truthyColor, falsyColor, ...labelProps}) => {
	return (
		<Label
			{...labelProps}
			icon={{name: `${value ? 'check ' : ''}square outline`}}
			color={value ? truthyColor : falsyColor}
		/>
	);
};

LabelCheckBox.defaultProps = {
	truthyColor: 'green',
	falsyColor: 'grey',
	value: false
};

LabelCheckBox.propTypes = {
	value: PropTypes.bool,
	truthyColor: colorTypes,
	falsyColor: colorTypes
};
export default LabelCheckBox;
